export default __webpack_public_path__ + "assets/help-square-dark.svg";